'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.MySwiper = void 0;
const $ = require("jquery");
const swiper_1 = require("swiper");
const swiper_2 = require("swiper");
class MySwiper {
    constructor() {
        // PICKUP
        const swiperSpecial = new swiper_1.default('.bulletSpecialSwiper', {
            modules: [swiper_2.Navigation, swiper_2.Autoplay, swiper_2.EffectFade],
            allowTouchMove: false,
            loop: true,
            effect: 'fade',
            speed: 500,
            navigation: {
                nextEl: ".trigSliderNext",
                prevEl: ".trigSliderPrev"
            },
            autoplay: {
                delay: 5000,
            },
            on: {
                slideChangeTransitionEnd: (e) => {
                    this.indexSpecial = e.realIndex + 1;
                    this.changeCopyText(this.indexSpecial);
                },
            }
        });
        //
        $('.trigSliderNext').on('click', () => {
            $('.bulletSliderCopy').find('p').attr('data-is-active', 'false');
        });
        $('.trigSliderPrev').on('click', () => {
            $('.bulletSliderCopy').find('p').attr('data-is-active', 'false');
        });
    }
    // Specialコンテンツのテキスト切り替え
    changeCopyText(index) {
        console.log(index);
        $('.bulletSliderCopy').children('p').attr('data-is-active', 'false');
        $(`.bulletSliderCopy[data-number="${index}"]`).children('p').attr('data-is-active', 'true');
    }
}
exports.MySwiper = MySwiper;
exports.default = MySwiper;
